import { config } from '@air/api';

import { COGNITO_CONFIG } from '../constants/cognitoConfig';

export const isApiConfiguredForFullAccountSignUp = () => {
  const savedAPIConfig = config.getAuthConfiguration();

  return savedAPIConfig?.authenticationFlowType === COGNITO_CONFIG.authenticationFlowType;
};
